export const NZ_HEALTH_DISTRICTS = [
  'N/A',
  'Auckland',
  'Bay of Plenty',
  'Canterbury',
  'Capital and Coast',
  'Counties Manukau',
  `Hawke's Bay`,
  'Hutt Valley',
  'Lakes',
  'MidCentral',
  'Nelson Marlborough',
  'Northland',
  'South Canterbury',
  'Southern',
  'Tairawhiti',
  'Taranaki',
  'Waikato',
  'Wairarapa',
  'Waitemata',
  'West Coast',
  'Whanganui',
];
